import axios from 'axios'
const JustAddedApi = {
    async getAll() {
       const justAdded = await axios.get('/api/just-added')
       return justAdded
    }
}

export default JustAddedApi